import { render } from "./AuthorRegistration.vue?vue&type=template&id=d85fd00c&scoped=true"
import script from "./AuthorRegistration.vue?vue&type=script&lang=js"
export * from "./AuthorRegistration.vue?vue&type=script&lang=js"

import "./AuthorRegistration.vue?vue&type=style&index=0&id=d85fd00c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d85fd00c"]])

export default __exports__